var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "review-step" },
    [
      _vm._t("status"),
      _c(
        "b-alert",
        {
          staticClass: "p-1 mb-2",
          attrs: { show: !_vm.noSale && _vm.published, variant: "success" },
        },
        [
          _c(
            "div",
            { staticClass: "flex items-center flex-wrap gap-2" },
            [
              _c("feather-icon", {
                staticClass: "flex-shrink-0",
                attrs: { icon: "CheckCircleIcon" },
              }),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("catalog.review.published_banner"))),
              ]),
              _vm.frontUrl
                ? _c(
                    "a",
                    {
                      staticClass: "review-step-link",
                      attrs: {
                        href: _vm.frontUrl,
                        target: "_blank",
                        rel: "noopener",
                      },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("catalog.review.see_listing")) + " "
                      ),
                      _c("feather-icon", {
                        attrs: {
                          icon: "ExternalLinkIcon",
                          svgClasses: "w-3 h-3",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c(
        "b-alert",
        {
          staticClass: "p-1 mb-2",
          attrs: { show: !_vm.noSale && !_vm.published, variant: "info" },
        },
        [
          _c(
            "div",
            { staticClass: "flex items-center gap-2" },
            [
              _c("feather-icon", {
                staticClass: "flex-shrink-0",
                attrs: { icon: "EyeOffIcon" },
              }),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("catalog.review.not_published_banner"))),
              ]),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "review-step-grid" },
        [
          _vm._l(_vm.summary, function (section) {
            return _c(
              "div",
              { key: section.key, staticClass: "review-step-card" },
              [
                _c(
                  "div",
                  { staticClass: "review-step-card-head" },
                  [
                    _c(
                      "h6",
                      { staticClass: "mb-0" },
                      [
                        section.icon
                          ? _c("feather-icon", {
                              staticClass: "mr-50",
                              attrs: {
                                icon: section.icon,
                                svgClasses: "w-4 h-4",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" " + _vm._s(section.title) + " "),
                      ],
                      1
                    ),
                    section.stepKey
                      ? _c(
                          "b-button",
                          {
                            attrs: { variant: "flat-primary", size: "sm" },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("goto", section.stepKey)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("catalog.review.edit")) + " "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "dl",
                  { staticClass: "review-step-rows" },
                  [
                    _vm._l(section.rows, function (row, index) {
                      return [
                        _c("dt", { key: "t-" + index }, [
                          _vm._v(_vm._s(row.label)),
                        ]),
                        _c(
                          "dd",
                          {
                            key: "d-" + index,
                            class: { "text-warning": row.missing },
                          },
                          [
                            _c(
                              "span",
                              {
                                ref: _vm.rowKey(section.key, index),
                                refInFor: true,
                                staticClass: "review-step-value",
                                class: {
                                  "review-step-value-clamped":
                                    !_vm.isRowExpanded(section.key, index),
                                },
                              },
                              [_vm._v(_vm._s(_vm.formatRowValue(row)))]
                            ),
                            _vm.isRowOverflowing(section.key, index)
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "review-step-toggle",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleRow(section.key, index)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.isRowExpanded(section.key, index)
                                            ? _vm.$t("catalog.review.see_less")
                                            : _vm.$t("catalog.review.see_more")
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]
                    }),
                  ],
                  2
                ),
              ]
            )
          }),
          !_vm.noSale
            ? _c(
                "div",
                { staticClass: "review-step-card review-step-price-card" },
                [
                  _c(
                    "div",
                    { staticClass: "review-step-card-head" },
                    [
                      _c(
                        "h6",
                        { staticClass: "mb-0" },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-50",
                            attrs: {
                              icon: "DollarSignIcon",
                              svgClasses: "w-4 h-4",
                            },
                          }),
                          _vm._v(
                            " " + _vm._s(_vm.$t("catalog.review.price")) + " "
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "flat-primary", size: "sm" },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("goto", _vm.priceStepKey)
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("catalog.review.edit")) + " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "review-step-price" }, [
                    _c("span", { staticClass: "review-step-price-value" }, [
                      _vm._v(_vm._s(_vm.priceLabel)),
                    ]),
                    _vm.priceSuffix
                      ? _c(
                          "small",
                          { staticClass: "review-step-price-suffix" },
                          [_vm._v(_vm._s(_vm.priceSuffix))]
                        )
                      : _vm._e(),
                  ]),
                  _vm.isFree
                    ? _c("small", { staticClass: "text-warning" }, [
                        _vm._v(_vm._s(_vm.$t("catalog.sale.free_notice"))),
                      ])
                    : _vm._e(),
                ]
              )
            : _vm._e(),
        ],
        2
      ),
      _c(
        "b-alert",
        {
          staticClass: "p-1 mt-2 mb-0",
          attrs: { show: _vm.blockers.length > 0, variant: "warning" },
        },
        [
          _c("div", { staticClass: "mb-50 font-weight-bold" }, [
            _vm._v(_vm._s(_vm.$t("catalog.review.blockers_title"))),
          ]),
          _c(
            "ul",
            { staticClass: "mb-0 pl-2" },
            _vm._l(_vm.blockers, function (blocker, index) {
              return _c(
                "li",
                { key: index },
                [
                  blocker.stepKey
                    ? _c(
                        "a",
                        {
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.$emit("goto", blocker.stepKey)
                            },
                          },
                        },
                        [_vm._v(_vm._s(blocker.text))]
                      )
                    : [_vm._v(_vm._s(blocker.text))],
                ],
                2
              )
            }),
            0
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "review-step-actions" },
        [
          _vm.noSale
            ? [
                _c(
                  "b-button",
                  {
                    attrs: {
                      variant: "primary",
                      size: "lg",
                      disabled: _vm.busy || _vm.blockers.length > 0,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("finish")
                      },
                    },
                  },
                  [
                    _c("feather-icon", {
                      staticClass: "mr-50",
                      attrs: { icon: "CheckIcon" },
                    }),
                    _c("span", { staticClass: "align-middle" }, [
                      _vm._v(_vm._s(_vm.$t("catalog.review.finish"))),
                    ]),
                  ],
                  1
                ),
              ]
            : !_vm.published
            ? [
                _c(
                  "b-button",
                  {
                    attrs: {
                      variant: "primary",
                      size: "lg",
                      disabled: _vm.busy || _vm.blockers.length > 0,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("publish")
                      },
                    },
                  },
                  [
                    _c("feather-icon", {
                      staticClass: "mr-50",
                      attrs: { icon: "GlobeIcon" },
                    }),
                    _c("span", { staticClass: "align-middle" }, [
                      _vm._v(_vm._s(_vm.$t("catalog.review.publish_now"))),
                    ]),
                  ],
                  1
                ),
                _c(
                  "b-button",
                  {
                    attrs: { variant: "outline-secondary", disabled: _vm.busy },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("save-draft")
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("catalog.review.save_draft")) + " "
                    ),
                  ]
                ),
              ]
            : [
                _c(
                  "b-button",
                  {
                    attrs: {
                      variant: "primary",
                      disabled: _vm.busy || _vm.blockers.length > 0,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("publish")
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("catalog.review.save_changes")) + " "
                    ),
                  ]
                ),
                _c(
                  "b-button",
                  {
                    attrs: { variant: "outline-danger", disabled: _vm.busy },
                    on: { click: _vm.confirmUnpublish },
                  },
                  [
                    _c("feather-icon", {
                      staticClass: "mr-50",
                      attrs: { icon: "EyeOffIcon" },
                    }),
                    _c("span", { staticClass: "align-middle" }, [
                      _vm._v(_vm._s(_vm.$t("catalog.review.unpublish"))),
                    ]),
                  ],
                  1
                ),
              ],
        ],
        2
      ),
      !_vm.noSale
        ? _c("small", { staticClass: "text-muted d-block mt-1" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.published
                    ? _vm.$t("catalog.review.publish_saves_all")
                    : _vm.$t("catalog.review.draft_explainer")
                ) +
                " "
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }